import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { BoxInput } from '../../../../../../../../../../atomic/inputs/boxInput/BoxInput';
import { Body3, fontSizes } from '../../../../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../../../../alertFormClass';
import style from './OrbSetupModule.module.css';

export const OrbSetupModule = observer(() => {
  const form = useAlertFormStore();
  return (
    <div className={`${style.container} noDragTag`}>
      <header className={style.header}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          ORB
        </Body3>
      </header>
      <div className={style.body}>
      <div className={style.inputAndLabel}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Candle Duration
          </Body3>
          <BoxInput
            value={form.setupDetails['ORB'].candleDuration}
            setValue={(value) =>
              form.setupDetails['ORB'].setCandleDuration(value)
            }
            backgroundColor={colors.grey}
            fontSize={fontSizes.body3}
            width="55px"
            height="20px"
            direction="right"
            symbol="min."
          />
        </div>
        <div className={style.inputAndLabel}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Break By
          </Body3>
          <BoxInput
            value={form.setupDetails['ORB'].breakBy}
            setValue={(value) =>
              form.setupDetails['ORB'].setBreakBy(value)
            }
            backgroundColor={colors.grey}
            fontSize={fontSizes.body3}
            width="55px"
            height="20px"
            direction="left"
            symbol="$"
          />
        </div>
      </div>
    </div>
  );
});
